var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-product-delete"},[_c('button',{staticClass:"c-button c-button--neutral c-button--tiny c-button--icon",attrs:{"title":_vm.$t(_vm.title),"type":"button"},on:{"click":_vm.confirm}},[_c('svgicon',{attrs:{"name":"close"}}),_vm._v(" "),(_vm.hasSlotData())?_c('span',[_vm._t("default")],2):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d339693a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/widgets/productDelete.vue
// module id = null
// module chunks = 